import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { salesService, SaleCreate, SaleFilters } from '@/services/sales';

export function useSales(filters?: SaleFilters) {
  return useQuery({
    queryKey: ['sales', filters],
    queryFn: () => salesService.getSales(filters),
  });
}

export function useSale(id: number | null) {
  return useQuery({
    queryKey: ['sale', id],
    queryFn: () => salesService.getSale(id!),
    enabled: !!id,
  });
}

export function useCreateSale() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SaleCreate) => salesService.createSale(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sales'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
    },
  });
}

export function useCancelSale() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => salesService.cancelSale(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sales'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}

export function useSalesByPatient(patientId: number | null) {
  return useQuery({
    queryKey: ['sales', 'patient', patientId],
    queryFn: () => salesService.getSalesByPatient(patientId!),
    enabled: !!patientId,
  });
}
